import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { NotificationProvider } from "./contexts/NotificationContext";
import { ToastProvider } from "./contexts/ToastContext";

import { AuthProvider } from "./contexts/AuthContext";
import GlobalErrorBoundary from "./components/GlobalErrorBoundary";

function App() {
  return (
    <GlobalErrorBoundary>
      <I18nextProvider i18n={i18n}>
        <AuthProvider>
          <ToastProvider>
            <NotificationProvider>
              <BrowserRouter basename={__BASE_PATH__}>
                <AppRoutes />
              </BrowserRouter>
            </NotificationProvider>
          </ToastProvider>
        </AuthProvider>
      </I18nextProvider>
    </GlobalErrorBoundary>
  );
}

export default App;
